'use strict';

angular.module('completeAir.version', [
    'completeAir.version.filters',
    'completeAir.version.version-directive',
    'completeAir.version.version-controller'
])
    .value('version', '0.1');
